export function getAssetsData (state, type) {
  const { assets } = state;

  return function getAssetsDataById (id) {
    const asset = Object.values(assets[type])
      .find(assetFromType => assetFromType[id]);

    return asset && asset[id];
  };
}
